<template>
    <div>
        <MementoDetails/>
    </div>
</template>
<script>
import MementoDetails from '@/components/components-planning/admin/memento/detail/MementoDetails.vue'

export default {
    components: {
        MementoDetails
    }
}

</script>